// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleFaq_wrapper__HHSwX","heading":"ArticleFaq_heading__L7aBw","item":"ArticleFaq_item__2VIx1"};